export const FAMILY_MEMBERS_COUNT = 3

export type PromoData = {
  url: string
  labelId: string
}
